import {
  useTranslate,
  useTable,
  CanAccess,
  Authenticated,
} from "@refinedev/core";
import { Table, Space, Button, Result } from "antd";
import { ColumnsType } from "antd/es/table";
import { NumberField, DateField, CreateButton, List } from "@refinedev/antd";
import { LinkOutlined, PlusOutlined } from "@ant-design/icons";
import { useOrganization } from "hooks/useOrganization";
import { Uuid } from "components/UUID";
import { ProductResponse } from "types";

const ProductsList = () => {
  const t = useTranslate();
  const { currentOrganization } = useOrganization({});

  const {
    tableQuery: { data, isLoading, isFetching },
    current,
    pageSize,
    setCurrent,
  } = useTable<ProductResponse>({
    resource: `media/${currentOrganization?.id}/products`,
    pagination: {
      mode: "server",
    },
  });

  const columns: ColumnsType<ProductResponse> = [
    {
      title: t("media.products.index.id"),
      dataIndex: "id",
      key: "id",
      render: (id: string) => <Uuid id={id} />,
      width: 150,
    },
    {
      title: t("media.products.index.sku"),
      dataIndex: "sku",
      key: "sku",
      width: 200,
    },
    {
      title: t("media.products.index.name"),
      dataIndex: "name",
      key: "name",
      render: (name: string, record) => (
        <Space size="small">
          <Button
            type="link"
            icon={<LinkOutlined />}
            href={record.url}
            target="_blank"
          />
          {name}
        </Space>
      ),
    },
    {
      title: t("media.products.index.price"),
      dataIndex: "price",
      key: "price",
      ellipsis: true,
      render: (price: string) => (
        <NumberField
          value={price}
          options={{
            style: "currency",
            currency: "EUR",
          }}
        />
      ),
    },
    {
      title: t("media.products.index.createdAt"),
      dataIndex: "created",
      key: "created",
      render: (date: string) => <DateField value={date} format="LLL" />,
    },
  ];

  return (
    <Authenticated key="products">
      <CanAccess
        resource="media_products"
        action="list"
        fallback={
          <Result
            status={403}
            title={t("media.media.create.accessForbidden")}
          />
        }
      >
        <List
          headerButtons={({ createButtonProps }) => (
            <CreateButton
              {...createButtonProps}
              icon={<PlusOutlined />}
              shape="round"
            >
              {t("media.products.index.create")}
            </CreateButton>
          )}
        >
          <Table
            columns={columns}
            dataSource={data?.data}
            loading={isLoading || isFetching}
            rowKey="sku"
            pagination={{
              current,
              pageSize,
              total: data?.total,
              onChange: (page) => {
                setCurrent(page);
              },
            }}
          />
        </List>
      </CanAccess>
    </Authenticated>
  );
};
export default ProductsList;
